import React, { useState } from "react";
import { DefaultModalLayout } from "../../../components/modal/layouts/default-modal-layout";
import { BUTTON_VARIANTS } from "../../../components/inputs/button-variants";
import { FormField } from "../../../components/form-field/form-field";
import { Input } from "../../../components/inputs/input/input";
import ListLayout from "../../../components/layouts/list-layout/list-layout";

interface IEditorLoginReasonModal {
    onCloseClick: () => void;
    onLoginAsEditor: (reason: string) => void;
}

const EditorLoginReasonModal: React.FC<IEditorLoginReasonModal> = ({ onCloseClick, onLoginAsEditor }) => {
    const [reason, setReason] = useState<string>("");

    const handleLoginClick = () => {
        onLoginAsEditor(reason);
    };

    const buttons = [
        {
            text: 'Cancel',
            variant: BUTTON_VARIANTS.Tertiary,
            onClick: onCloseClick
        },
        {
            text: 'Login as Editor',
            variant: BUTTON_VARIANTS.Primary,
            disabled: !reason.trim(),
            onClick: handleLoginClick
        }
    ];

    return (
        <DefaultModalLayout
            isCloseDisabled={false}
            onCloseClicked={onCloseClick}
            buttons={buttons}
        >
            <div className="editor-login-reason-modal">
                <ListLayout>
                    <FormField label="Reason">
                        <Input
                            type="text"
                            value={reason}
                            placeholder="Enter reason for logging in as editor"
                            onChange={(value) => setReason(value)}
                        />
                    </FormField>
                </ListLayout>
            </div>
        </DefaultModalLayout>
    );
};

export default EditorLoginReasonModal;

